export enum AclRoleLevel {
  App = 'app',
  Environment = 'environment',
}
